var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHillXl2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2600,
    height: 339,
    viewBox: "0 0 2600 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2600 23.9988C2600 23.9988 2183.61 1.08169 1886.81 1.25356C1595.28 1.42237 1502.22 47.2622 1188.06 23.9988C987.413 9.14157 552.5 -4.22361 418.889 1.25356C285.278 6.73073 -3.8147e-05 23.9988 -3.8147e-05 23.9988V223H2600V23.9988Z",
    fill: "#E4D7C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 101.428C0 101.428 473.056 68.1846 713.194 88.6605C978.822 111.31 1048.99 92.7758 1373.13 95.2235C1705.35 97.7322 1936.46 77 2149.51 77C2362.57 77 2600 101.428 2600 101.428V187.49H0V101.428Z",
    fill: "#E2DCD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2600 155.182C2600 155.182 2408.64 123.915 2120.62 134.72C1888.61 143.424 1894.79 151.044 1606.94 155.182C1377.89 158.474 660.833 132 448.681 132C236.528 132 -3.8147e-05 155.182 -3.8147e-05 155.182V339H2600V155.182Z",
    fill: "#F2EBDB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHillXl2);
export default __webpack_public_path__ + "static/media/hill-xl-2.1d6baa36.svg";
export { ForwardRef as ReactComponent };